// prettier-ignore
const AUTO_TEXTO_CERTIDAO = {
    VOTO_VENCIDO: {
        id: 'VOTO_VENCIDO',
        legenda: 'Voto vencido',
        texto: 'por maioria, vencid'
    },
    REDATOR: {
        id: 'REDATOR',
        legenda: 'Redator designado',
        texto: ' redigirá o acórdão'
    },
    JUNTADA_VOTO_VENCIDO: {
        id: 'JUNTADA_VOTO_VENCIDO',
        legenda: 'Juntada de voto vencido',
        texto: ' juntará voto vencido'
    },
    JUNTADA_VOTO_CONVERGENTE: {
        id: 'JUNTADA_VOTO_CONVERGENTE',
        legenda: 'Juntada de voto convergente',
        texto: ' juntará voto convergente'
    },
    RESSALVA_ENTENDIMENTO: {
        id: 'RESSALVA_ENTENDIMENTO',
        legenda: 'Ressalva de entendimento',
        texto: ' registrou ressalva de entendimento pessoal'
    },
    RESSALVA_FUNDAMENTACAO: {
        id: 'RESSALVA_FUNDAMENTACAO',
        legenda: 'Ressalva de fundamento',
        texto: ' registrou ressalva de fundamentação'
    },
    REGISTRO_IMPEDIMENTO: {
        id: 'REGISTRO_IMPEDIMENTO',
        legenda: 'Impedimento',
        texto: 'impedimento averbado pel'
    },
    REGISTRO_PARTICIPACAO_VIRTUAL: {
        id: 'REGISTRO_PARTICIPACAO_VIRTUAL',
        legenda: '',
        texto: '#ADV_CAP_GEN2 Dr#ADV_GEN. #NOME_ADV, patron#ADV_GEN2 da parte #NOME_PARTE, participou da sessão virtual nos termos do § 2º-A do art. 134 do RITST'
    },
    REGISTRO_PRESENCA: {
        id: 'REGISTRO_PRESENCA',
        legenda: 'Registro de presença',
        texto: '#ADV_CAP_GEN2 Dr#ADV_GEN. #NOME_ADV, patron#ADV_GEN2 da parte #NOME_PARTE, esteve presente à sessão'
    },
    REGISTRO_PRESENCA_TELEPRESENCIAL: {
        id: 'REGISTRO_PRESENCA_TELEPRESENCIAL',
        legenda: '',
        texto: '#ADV_CAP_GEN2 Dr#ADV_GEN. #NOME_ADV, patron#ADV_GEN2 da parte #NOME_PARTE, esteve presente à sessão, por meio de videoconferência'
    },
    SUSTENTACAO_ORAL: {
        id: 'SUSTENTACAO_ORAL',
        legenda: 'Sustentação Oral',
        texto: '#ADV_CAP_GEN2 Dr#ADV_GEN. #NOME_ADV falou pela parte #NOME_PARTE'
    },
    SUSTENTACAO_ORAL_TELEPRESENCIAL: {
        id: 'SUSTENTACAO_ORAL_TELEPRESENCIAL',
        legenda: '',
        texto: '#ADV_CAP_GEN2 Dr#ADV_GEN. #NOME_ADV falou pela parte #NOME_PARTE, por meio de videoconferência'
    },
    SUSTENTACAO_ORAL_ELETRONICA: {
        id: 'SUSTENTACAO_ORAL_ELETRONICA',
        legenda: '',
        texto: '#ADV_CAP_GEN2 Dr#ADV_GEN. #NOME_ADV falou pela parte #NOME_PARTE, por meio de arquivo eletrônico de sustentação oral, nos termos do art. 134-A, § 3°, RITST'
    },
    PEDIDO_DESTAQUE: {
        id: 'PEDIDO_DESTAQUE',
        legenda: '',
        texto: '#ADV_CAP_GEN2 Dr#ADV_GEN. #NOME_ADV, representante da parte #NOME_PARTE, requereu destaque, nos termos do art. 135, II, RITST'
    },
    JUNTADA_PROCURACAO: {
        id: 'JUNTADA_PROCURACAO',
        legenda: 'Procuração / Substab.',
        texto: 'A presidência da #TURMA deferiu a juntada de instrumento de mandato, requerida da tribuna pel#ADV_GEN2 procurador#ADV_GEN'
    },
    JUNTADA_PROCURACAO_PJE: {
        id: 'JUNTADA_PROCURACAO_PJE',
        legenda: '',
        texto: 'A presidência da #TURMA deferiu a juntada de instrumento de mandato, requerida da tribuna pel#ADV_GEN2 procurador#ADV_GEN'
    },
    REGISTRO_AUSENCIA: {
        id: 'REGISTRO_AUSENCIA',
        legenda: 'Ausência justificada',
        texto: 'ausente, justificadamente, '
    }
};

export default AUTO_TEXTO_CERTIDAO;
